<div id="app-cont" [ngClass]="['altoProduccion',esProduccion?'':'altoPre']">
    <box-loader *ngIf="!session.inicioInstanciaSession, else load" [mensaje]="'Iniciando sistema'"></box-loader>
    <ng-template #load>

        <!--nav-tabs ></nav-tabs--> <!--LO HABILITO SI HAY MAS TIPOS CONSULTAS EN UN FUTURO-->
        <router-outlet></router-outlet>
    </ng-template>
</div>